const NewButton = () => (
  <div className="text-xs px-2 py-1 bg-[#FF0000] text-white italic font-semibold rounded">
    NEW
  </div>
);

export default NewButton;
